<template>
  <div v-if="applicantSkills" class="custom-accordion--content">
    <div class="vx-row">
      <div
        v-for="input in applicantSkills.results"
        :key="input.id"
        class="vx-col w-full md:w-1/4"
      >
        <DataInput
          v-if="input.inputType === 'SELECT'"
          v-model="values[input.id]"
          type="select"
          :options="options"
          :label="input.name"
          class="mb-2"
          :name="input.id"
          @input="v => changeValue(input.id, v)"
        />
        <DataInput
          v-else-if="input.inputType === 'BOOLEAN'"
          v-model="values[input.id]"
          type="bool"
          :label="input.name"
          class="mb-2"
          :name="input.id"
          @input="v => changeValue(input.id, v)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import DataInput from "@/components/ui/DataInput";

export default {
  components: {
    DataInput
  },
  props: {
    profileId: { type: String, required: true },
    value: {
      type: String,
      required: true
    },
    group: {
      type: String,
      required: true
    }
  },
  apollo: {
    applicantSkills: {
      query: gql`
        query($categoryId: ID!) {
          applicantSkills(category: $categoryId, page: 1, size: 100) {
            results {
              id
              name
              inputType
            }
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return {
          categoryId: this.value
        };
      },
      result(v) {
        if (v.data && v.data.applicantSkills) {
          this.skillIDs = v.data.applicantSkills.results.map(v => v.id);
        }
        this.$emit("loaded");
      }
    },
    applicantSkillValues: {
      query: gql`
        query($group: ID!) {
          applicantSkillValues(group: $group, page: 1, size: 45) {
            results {
              id
              name
            }
          }
        }
      `,
      skip() {
        return !this.group;
      },
      fetchPolicy: "network-only",
      variables() {
        return {
          group: this.group
        };
      }
    },
    applicantProfileSkillValues: {
      query: gql`
        query($skills: [ID!]!, $profile: ID!) {
          applicantProfileSkillValues(profile: $profile, skills: $skills) {
            skill {
              id
            }
            value
            active
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        return {
          skills: this.skillIDs,
          profile: this.profileId
        };
      },
      skip() {
        return !this.skillIDs || !this.skillIDs.length;
      },
      result(v) {
        if (v.data && v.data.applicantProfileSkillValues) {
          this.values = {};
          v.data.applicantProfileSkillValues.forEach(e => {
            this.$set(this.values, e.skill.id, e.value);
          });
        }
      }
    }
  },
  data: () => ({
    skillIDs: null,
    values: []
  }),
  computed: {
    options() {
      if (!this.applicantSkillValues) {
        return [];
      }

      return this.applicantSkillValues.results.map((e, i) => ({
        label: e.name,
        code: i
      }));
    }
  },
  methods: {
    changeValue(input, value) {
      this.$apollo.mutate({
        mutation: gql`
          mutation($id: ID!, $input: ApplicantProfileSkillValueInput!) {
            saveApplicantProfileSkill(applicantProfile: $id, input: $input) {
              value
            }
          }
        `,
        variables: {
          id: this.profileId,
          input: {
            skillID: input,
            value: value !== null ? +value : null,
            active: true
          }
        }
      });
    }
  }
};
</script>
